import React, { Component } from 'react';
import { connect } from 'react-redux';
import SettingsNavBar from './SettingsNavBar';
import SideBar from '../../components/SideBar';
import { openModal, clearPasswordStatuses, resetPasswordWithOldPassword } from '../../actions';

class Password extends Component {
  constructor() {
    super();
    this.state = {
      blankPassError: false,
      blankNewPassError: false,
      blankConfirmError: false,
      matchError: false,
      password: '',
      newPassword: '',
      confirmPassword: '',
    };
  }

  componentDidMount() {
    this.props.clearPasswordStatuses();
  }

  componentWillUnmount() {
    this.props.clearPasswordStatuses();
  }

  handleChange = (event) => {
    this.props.clearPasswordStatuses();
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = () => {
    this.props.clearPasswordStatuses();
    this.setState((prevState) => {
      return {
        blankPassError: prevState.password === '',
        blankNewPassError: prevState.newPassword === '',
        blankConfirmError: prevState.confirmPassword === '',
        matchError: prevState.newPassword !== prevState.confirmPassword,
      };
    }, () => {
      if (
        !this.state.blankPassError
      && !this.state.blankNewPassError
      && !this.state.blankConfirmError
      && !this.state.matchError
      ) {
        this.props.resetPasswordWithOldPassword(this.props.userid, this.state.password, this.state.newPassword);
      }
    });
  }

  render() {
    return (
      <div className="flex-container">
        <SideBar defaultPage="account" />
        <SettingsNavBar defaultPage="password" />
        <div className="profile-container">
          <h2 className="color account-header">Password</h2>
          <div className="profile-body-container">
            <div className="box profile-form-container">
              <div className="form-row-container">
                <label className="long-label" htmlFor="firstName">
                  Current password
                  {this.state.blankPassError ? <p className="error-text">This field cannot be left blank</p> : null}
                  <input type="password" name="password" value={this.state.password} onChange={this.handleChange} />
                </label>
              </div>
              <div className="form-row-container">
                <label className="short-label" htmlFor="firstName">
                  New Password
                  {this.state.blankNewPassError ? <p className="error-text">This field cannot be left blank</p> : null}
                  <input type="password" name="newPassword" value={this.state.newPassword} onChange={this.handleChange} />
                </label>
                <label className="short-label" htmlFor="firstName">
                  Re-type new password
                  {this.state.blankConfirmError ? <p className="error-text">This field cannot be left blank</p> : null}
                  {this.state.matchError ? <p className="error-text">These passwords do not match</p> : null}
                  <input type="password" name="confirmPassword" value={this.state.confirmPassword} onChange={this.handleChange} />
                </label>
              </div>
              {this.props.resetError ? <p className="settings-error-text">There was an error resetting your password.</p> : null}
              {this.props.resetSuccess ? <p className="settings-success-text">Your password has been successfully updated</p> : null}
              <button onClick={this.handleSubmit} className="save-button" type="button">Save</button>
              <div className="forgot-settings-page" onClick={() => this.props.openModal('ForgotPass')} role="button" tabIndex={0}>
                Forgot Password?
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userid: state.user.userid,
  resetError: state.password.resetError,
  resetSuccess: state.password.passwordResetSuccess,
});

export default connect(mapStateToProps, { openModal, clearPasswordStatuses, resetPasswordWithOldPassword })(Password);
